// extracted by mini-css-extract-plugin
export default {"cartItems":"cart-items___CFTOZ"};